// Check if Swiper is available
function isSwiperAvailable() {
  return typeof Swiper !== 'undefined';
}

// Initialize featured collection swiper
function initializeFeaturedCollectionSwiper() {
  if (!isSwiperAvailable()) {
    setTimeout(initializeFeaturedCollectionSwiper, 100);
    return;
  }

  const swiperElements = document.querySelectorAll(".featured-collection-swiper");

  if (swiperElements.length === 0) {
    return;
  }

  swiperElements.forEach((swiperElement, index) => {
    // Check if already initialized
    if (swiperElement.swiper) {
      return;
    }

    // Check if swiper has slides
    const slides = swiperElement.querySelectorAll('.swiper-slide');
    if (slides.length === 0) {
      return;
    }

    let desktopPerView = swiperElement.getAttribute("data-desktop-per-view") || 4;
    let tabletPerView = swiperElement.getAttribute("data-tablet-per-view") || 3;
    let mobilePerView = swiperElement.getAttribute("data-mobile-per-view") || 1.2;

    try {
      const featuredCollectionSwiper = new Swiper(swiperElement, {
        spaceBetween: 15,
        loop: true,
        slidesPerView: 1.5,
        breakpoints: {
          375: {
            slidesPerView: parseFloat(mobilePerView),
            spaceBetween: 16,
          },
          750: {
            slidesPerView: parseFloat(tabletPerView),
            spaceBetween: 16,
          },
          990: {
            slidesPerView: parseFloat(desktopPerView),
            spaceBetween: 16,
          },
        },
      });

      // Mark as initialized
      swiperElement.setAttribute('data-swiper-initialized', 'true');

    } catch (error) {
      // Silent error handling
    }
  });
}

// Initialize the instagram gallery swiper
function initializeInstagramGallerySwiper() {
  if (!isSwiperAvailable()) {
    setTimeout(initializeInstagramGallerySwiper, 100);
    return;
  }

  const swiperElement = document.querySelector(".instagram-gallery-swiper");

  if (swiperElement === null) {
    return;
  }

  try {
    new Swiper(".instagram-gallery-swiper", {
      spaceBetween: 5,
      loop: true,
      slidesPerView: 2.3,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        750: {
          slidesPerView: 2.8,
        },
        990: {
          slidesPerView: 3.7,
        },
      },
    });

    // Mark as initialized
    swiperElement.setAttribute('data-swiper-initialized', 'true');
  } catch (error) {
    // Silent error handling
  }
}

// Initialize all swipers when DOM is ready
function initializeAllSwipers() {
  initializeFeaturedCollectionSwiper();
  initializeInstagramGallerySwiper();
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllSwipers);
} else {
  // DOM is already ready
  initializeAllSwipers();
}

// Also initialize on page load (for dynamic content)
window.addEventListener('load', initializeAllSwipers);

// Reinitialize swipers when new content is loaded (for dynamic sections)
function reinitializeSwipers() {
  // Destroy existing swipers first
  document.querySelectorAll('.featured-collection-swiper').forEach(element => {
    if (element.swiper) {
      element.swiper.destroy(true, true);
    }
  });

  document.querySelectorAll('.instagram-gallery-swiper').forEach(element => {
    if (element.swiper) {
      element.swiper.destroy(true, true);
    }
  });

  // Reinitialize after a short delay
  setTimeout(initializeAllSwipers, 100);
}

// Make reinitializeSwipers available globally for other scripts
window.reinitializeSwipers = reinitializeSwipers;

// Watch for dynamically loaded product recommendations
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const target = mutation.target;
      if (target.classList.contains('product-recommendations--loaded')) {
        setTimeout(initializeAllSwipers, 200); // Small delay to ensure DOM is updated
      }
    }

    if (mutation.type === 'childList') {
      // Check if any new swiper elements were added
      const addedNodes = Array.from(mutation.addedNodes);
      const hasSwiperElements = addedNodes.some(node => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          return node.querySelector && (
            node.querySelector('.featured-collection-swiper') ||
            node.querySelector('.instagram-gallery-swiper') ||
            node.classList.contains('featured-collection-swiper') ||
            node.classList.contains('instagram-gallery-swiper')
          );
        }
        return false;
      });

      if (hasSwiperElements) {
        setTimeout(initializeAllSwipers, 200);
      }
    }
  });
});

// Start observing
observer.observe(document.body, {
  attributes: true,
  childList: true,
  subtree: true,
  attributeFilter: ['class']
});

// Fallback: Check for new swiper elements every 2 seconds for the first 10 seconds
let fallbackCheckCount = 0;
const fallbackInterval = setInterval(() => {
  fallbackCheckCount++;

  // Check if there are any uninitialized swiper elements
  const uninitializedSwipers = document.querySelectorAll('.featured-collection-swiper:not([data-swiper-initialized]), .instagram-gallery-swiper:not([data-swiper-initialized])');

  if (uninitializedSwipers.length > 0) {
    initializeAllSwipers();
  }

  // Stop checking after 10 seconds (5 checks)
  if (fallbackCheckCount >= 5) {
    clearInterval(fallbackInterval);
  }
}, 2000);
